import { jsxs, jsx } from "react/jsx-runtime";
import { useContext, Fragment } from "react";
import PropTypes from "prop-types";
import { defaultTo, get } from "lodash/fp";
import { tensorGridContext } from "./tensor-grid-context.es.js";
import { TensorGridInput } from "./tensor-grid-input.es.js";
import { TensorGridItemCell, TensorGridItemLabel } from "./tensor-grid-item.styles.es.js";
const propTypes = {
  column: PropTypes.string.isRequired,
  editMode: PropTypes.bool,
  firstColumn: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      next: PropTypes.shape({
        column: PropTypes.string,
        // eslint-disable-next-line react/forbid-prop-types
        items: PropTypes.arrayOf(PropTypes.object)
      }),
      span: PropTypes.number.isRequired,
      value: PropTypes.string.isRequired
    })
  ),
  lastRow: PropTypes.bool,
  onChange: PropTypes.func,
  onEditModeChange: PropTypes.func
};
const defaultProps = {
  editMode: false,
  firstColumn: false,
  lastRow: false,
  onChange: void 0,
  onEditModeChange: void 0
};
const TensorGridItem = ({
  column,
  editMode,
  firstColumn,
  items,
  lastRow,
  onChange,
  onEditModeChange
}) => {
  const { align, dataType, editable, format, max, min, step, units } = defaultTo({}, get(column, useContext(tensorGridContext)));
  return items.map((item, i) => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      TensorGridItemCell,
      {
        $lastColumn: !item.next,
        $lastRow: lastRow && i === items.length - 1,
        rowSpan: item.span,
        children: editable ? /* @__PURE__ */ jsx(
          TensorGridInput,
          {
            align,
            column,
            dataType,
            editMode,
            firstColumn,
            format,
            itemKey: item.key,
            lastColumn: !item.next,
            lastRow: lastRow && i === items.length - 1,
            max,
            min,
            onChange,
            onEditModeChange,
            step,
            units,
            value: item.value
          }
        ) : /* @__PURE__ */ jsx(TensorGridItemLabel, { $align: align, $firstColumn: firstColumn, children: format ? format(item.value) : item.value })
      }
    ),
    item.next && /* @__PURE__ */ jsx(
      TensorGridItem,
      {
        column: item.next.column,
        editMode,
        items: item.next.items,
        lastRow: lastRow && i === items.length - 1,
        onChange,
        onEditModeChange
      }
    )
  ] }, `${column}___${item.key || item.value}`));
};
TensorGridItem.propTypes = propTypes;
TensorGridItem.defaultProps = defaultProps;
export {
  TensorGridItem
};
